export default __webpack_public_path__ + "static/media/fallout-stone-1.7b314630.png";